<template>
  <div v-if="content" v-editable="content" class="business-text">
    <div class="text">
      <vue-markdown class="markdown">{{content.text}}</vue-markdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.business-text {
  width: $content-width;
  margin: auto;
  max-width: $max-width;
  padding: 1em 0;
  .markdown {
    white-space: pre-wrap;
    p, div, ul, li, span {
        @apply md:text-lg text-base text-center text-gray-500 font-medium;
    }
    strong {
        @apply font-bold;
    }
  }
}
</style>
